// Initialize mobile menu and data-theme toggle
(function() {
    document.addEventListener('click', function(e) {
        // Mobile Menu Trigger
        var burger = e.target.closest('.gh-burger');
        if (burger) {
            var isOpen = document.body.classList.toggle('gh-head-open');
            burger.setAttribute('aria-expanded', String(isOpen));
            return;
        }

        // Theme Mode Toggle (Sun/Moon)
        var themeBtn = e.target.closest('.vanta-theme-toggle');
        if (themeBtn) {
            e.preventDefault();
            var html = document.documentElement;
            var currentTheme = html.getAttribute('data-theme') || 'dark';
            var nextTheme = currentTheme === 'light' ? 'dark' : 'light';
            html.setAttribute('data-theme', nextTheme);
            html.classList.toggle('dark', nextTheme === 'dark');
            html.classList.toggle('light', nextTheme === 'light');
            try { localStorage.setItem('vanta-theme', nextTheme); } catch (err) {}
        }
    });
})();
